export const trigger = `
  inline-flex items-center justify-between flex-1
  bg-ll-background rounded-sm border
  py-1 pr-2 pl-3 min-w-[120px]
  data-[size=medium]:text-ll-font-size-p data-[size=medium]:h-8
  data-[size=large]:text-ll-font-size-h6 data-[size=large]:h-10
`;

export const content = `
  overflow-hidden bg-ll-background rounded-sm shadow-md
  z-10 min-w-[120px]
  data-[size=medium]:text-ll-font-size-p
  data-[size=large]:text-ll-font-size-h6
`;

export const item = `
  font-sans font-inherit py-1 pr-8 pl-6 outline-none
  relative rounded-sm cursor-default text-ll-on-surface-variant1

  data-[highlighted]:[&:not([data-variant="light"])]:bg-ll-primary
  data-[highlighted]:[&:not([data-variant="light"])]:text-ll-on-primary

  // Special color between now and design system
  data-[highlighted]:[&:not([data-variant="dark"])]:bg-[#EBF5F7]
  data-[highlighted]:[&:not([data-variant="dark"])]:text-ll-on-surface
  `;

export const viewport = `font-inherit p-0`;

export const itemIndicator = `
  absolute left-0 bottom-0
  inline-flex justify-center items-center
  h-full w-6
`;
